// @flow

import React, { Component } from 'react';
import './CollegeDetails.css';

import {
  percentFormater,
  integerFormater,
  populationFormater,
  dollarFormater,
  numericToString,
  numericRangeToString,
} from './Formatters';

import { CONTROL_TYPES } from './Constants';
import Tips from '../components/Tooltip/Tips';
import Tip from '../components/Tooltip/Tip';

class CollegeDetails extends Component {
  render() {
    const { college } = this.props;
    const admissionRateString = numericToString(college.ADM_RATE, percentFormater);
    const countString = numericToString(college.UGDS, populationFormater);
    const averageCostString = numericToString(college.averageCost, dollarFormater);
    const netPrice = numericToString(college.netPrice, dollarFormater);
    const inStateTuitionString = numericToString(college.TUITIONFEE_IN, dollarFormater);
    const outOfStateTuitionString = numericToString(college.TUITIONFEE_OUT, dollarFormater);

    const satRange = numericRangeToString(
      college.satCombined25,
      college.satCombined75,
      integerFormater,
    );

    const actRange = numericRangeToString(college.ACTCM25, college.ACTCM75, integerFormater);

    const lateCompletionLabel = college.fourYear
      ? 'Six Year Completion Rate'
      : 'Three Year Completion Rate';
    const onTimeCompletionString = numericToString(college.onTimeCompletionRate, percentFormater);
    const lateCompletionString = numericToString(college.extraTimeCompletionRate, percentFormater);

    const earningsAtSix = numericToString(college.MN_EARN_WNE_P6, dollarFormater);
    const earningsAtTen = numericToString(college.MN_EARN_WNE_P10, dollarFormater);

    const repaymentRateAt3 = numericToString(college.RPY_3YR_RT, percentFormater);
    const repaymentRateAt7 = numericToString(college.RPY_7YR_RT, percentFormater);

    const controlType = CONTROL_TYPES[college.CONTROL] ? CONTROL_TYPES[college.CONTROL] : 'Unknown';

    const urlString = `http://${college.INSTURL}`;

    const netPriceLabel =
      CONTROL_TYPES[college.CONTROL] === 'Public'
        ? 'Average Net Price (In State)'
        : 'Average Net Price';

    return (
      <div className="CollegeDetails">
        <h3>
          <a href={urlString} target="_blank">
            {college.INSTNM}
          </a>
        </h3>
        <Tips>
          <Tip label="Students" value={countString} />
          <Tip label="Institution Type" value={controlType} />
          <Tip label="Admission Rate" value={admissionRateString} />
          <div>&nbsp;</div>
          <Tip label="SAT Range" value={satRange} />
          <Tip label="ACT Range" value={actRange} />
          <div>&nbsp;</div>
          <Tip label="Average Listed Cost" value={averageCostString} />
          <Tip label={netPriceLabel} value={netPrice} />
          <Tip label="In State Tuition" value={inStateTuitionString} />
          <Tip label="Out of State Tuition" value={outOfStateTuitionString} />
          <div>&nbsp;</div>
          <Tip label="Ontime Completion Rate" value={onTimeCompletionString} />
          <Tip label={lateCompletionLabel} value={lateCompletionString} />
          <div>&nbsp;</div>
          <Tip label="Earnings 6 Years after Enrollment" value={earningsAtSix} />
          <Tip label="Earnings 10 Years after Enrollment" value={earningsAtTen} />
          <div>&nbsp;</div>
          <Tip label="Repayment Progress 3 Years Later" value={repaymentRateAt3} />
          <Tip label="Repayment Progress 7 Years Later" value={repaymentRateAt7} />
        </Tips>
      </div>
    );
  }
}

export default CollegeDetails;



// WEBPACK FOOTER //
// ./src/App/CollegeDetails.js